import * as constants from './actions';
import { GO_NEXT_ACTION } from '../Widget/actions';

import { getInitiatedTime } from '../../utils/actionTiming';

const initialState = {
    actionInitiated: false,
    answerId: null,
    isSubmitting: false,
    pollAnswered: false,
    resultDistribution: []
};

export default function sentimentPoll(state = initialState, { type, payload }) {
    switch (type) {
        case constants.SENTIMENT_POLL_ANSWERED:
            return {
                ...state,
                pollAnswered: true
            };
        case constants.PRESET_DISTRIBUTION_DATA:
            return {
                ...state,
                resultDistribution: payload
            };
        case constants.SENTIMENT_POLL_ANSWER_SUBMITTING:
            return {
                ...state,
                isSubmitting: payload
            };
        case constants.SENTIMENT_POLL_SUCCESS:
            const answerHistory = state.answerHistory || [];
            const existing = answerHistory.find(
                a =>
                    a.id === payload.answerId &&
                    a.actionIdentifier === payload.actionIdentifier
            );
            if (existing) {
                existing.sentimentValue = payload.sentimentValue;
            } else {
                answerHistory.push({
                    id: payload.answerId,
                    sentimentValue: payload.sentimentValue,
                    actionIdentifier: payload.actionIdentifier
                });
            }
            return {
                ...state,
                answerId: payload.answerId,
                resultDistribution: payload.resultDistribution,
                feedbackText: payload.feedbackText,
                questionText: payload.questionText,
                sentimentValue: payload.sentimentValue,
                noOfAnswers: payload.noOfAnswers,
                answerHistory
            };
        case constants.SENTIMENT_POLL_INITIATED:
            return {
                ...state,
                actionInitiated: true,
                actionIdentifier: [payload],
                ...getInitiatedTime(payload, state)
            };
        case GO_NEXT_ACTION:
            return {
                ...state,
                pollAnswered: false
            };
        default:
            return state;
    }
}
